<script lang="ts">
  import { cn } from '$lib/utils';

  import type { HTMLAttributes } from 'svelte/elements';

  type $$Props = HTMLAttributes<HTMLDivElement> & {
    sticky?: boolean;
  };
  export let sticky: boolean = true;

  let className: $$Props['class'] = undefined;
  export { className as class };
</script>

<header
  class={cn(
    'border-border/40 bg-background/95 supports-[backdrop-filter]:bg-background/60 z-50 w-full border-b backdrop-blur',
    sticky && 'sticky top-0 z-50 w-full border-b backdrop-blur',
    className
  )}
>
  <slot />
</header>
